const GROUP_READ_STORAGE_KEY = 'greenwich_group_reads_v1';

const normalizeTimestamp = (value) => {
  if (!value) return null;
  const timestamp = new Date(value).getTime();
  return Number.isFinite(timestamp) ? timestamp : null;
};

const readGroupSeenMap = () => {
  try {
    const raw = localStorage.getItem(GROUP_READ_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
};

const writeGroupSeenMap = (map) => {
  try {
    localStorage.setItem(GROUP_READ_STORAGE_KEY, JSON.stringify(map));
    window.dispatchEvent(new CustomEvent('groupMessageReadStateChanged'));
  } catch {
    // Ignore storage write errors and keep UI functional.
  }
};

export const getGroupUnreadCount = (groups = [], currentUserId = '') => {
  const seenMap = readGroupSeenMap();

  return groups.reduce((count, group) => {
    const lastMessage = group?.lastMessage;
    const groupId = group?._id || group?.id;
    const messageTime = normalizeTimestamp(lastMessage?.createdAt || group?.updatedAt);
    const senderId = lastMessage?.sender?._id || lastMessage?.sender?.id || lastMessage?.sender;
    const seenTime = normalizeTimestamp(seenMap[groupId]);

    if (!groupId || !messageTime) return count;
    if (senderId && currentUserId && senderId === currentUserId) return count;
    if (!seenTime || messageTime > seenTime) return count + 1;

    return count;
  }, 0);
};

export const isGroupUnread = (group, currentUserId = '') => {
  return getGroupUnreadCount([group], currentUserId) > 0;
};

export const markGroupAsRead = (groupId, timestamp = new Date().toISOString()) => {
  if (!groupId) return;
  const next = {
    ...readGroupSeenMap(),
    [groupId]: timestamp,
  };
  writeGroupSeenMap(next);
};
